module.exports = __webpack_public_path__ + "img/dpd_auto.cc2724f3.jpg";